// extracted by mini-css-extract-plugin
module.exports = {"link":"button_link__1H2gq","logo":"button_logo__2ZOi3"};